import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-up-right', 'ArrowLongUpRight', [["path",{"d":"M19 11V5h-6m6 0L5 19","key":"svg-0"}]]);